"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _component = _interopRequireDefault(require("@loadable/component"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ReactSingleImage = _interopRequireDefault(require("./ReactSingleImage01.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ReactHTMLPicture = (0, _component.default)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("@micado-digital/react-htmlpicture/ReactHTMLPicture"));
  });
});
var ReactLink = (0, _component.default)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("@micado-digital/react-link/ReactLink"));
  });
});

var ReactSingleImage01 = function ReactSingleImage01(_ref) {
  var addition = _ref.addition,
      alt = _ref.alt,
      media = _ref.media,
      mediaFormats = _ref.mediaFormats,
      mediaPath = _ref.mediaPath,
      option2 = _ref.option2,
      reference = _ref.reference,
      text = _ref.text,
      title = _ref.title;
  var css = (0, _ReactSingleImage.default)();
  var htmlTitle = title ? /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: "mco-singleimage-01__content-title",
    component: "p",
    dangerouslySetInnerHTML: {
      __html: title
    },
    variant: "subtitle2"
  }) : "";
  var htmlText = text ? /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: "mco-singleimage-01__content-text",
    component: "div",
    dangerouslySetInnerHTML: {
      __html: text
    },
    variant: "subtitle1"
  }) : "";
  var textBox = htmlTitle || htmlText ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("mco-singleimage-01__content", css.content)
  }, htmlTitle, htmlText) : "";

  var image = /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: (0, _clsx.default)("mco-singleimage-01__image", css.image)
  }, /*#__PURE__*/_react.default.createElement(ReactHTMLPicture, _extends({
    alt: alt,
    media: media,
    path: mediaPath,
    webpFallback: true
  }, mediaFormats)));

  var wrap = function wrap(image, text) {
    if (addition) {
      return /*#__PURE__*/_react.default.createElement(ReactLink, {
        to: addition,
        target: option2 === 1 ? "_blank" : "_self",
        rel: "noreferrer"
      }, image, text);
    } else if (reference && reference !== null && reference !== void 0 && reference.pageName) {
      return /*#__PURE__*/_react.default.createElement(ReactLink, {
        to: reference.pageName
      }, image, text);
    } else {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, image, text);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: "mco-singleimage-01"
  }, wrap(image, textBox));
};

ReactSingleImage01.propTypes = {
  addition: _propTypes.default.string,
  media: _propTypes.default.object.isRequired,
  mediaFormats: _propTypes.default.object,
  mediaPath: _propTypes.default.string,
  option2: _propTypes.default.number,
  reference: _propTypes.default.object,
  text: _propTypes.default.string,
  title: _propTypes.default.string
};
var _default = ReactSingleImage01;
exports.default = _default;